"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApproxFormulaUtil = void 0;
class ApproxFormulaUtil {
    /**
     * Creates a linear formular f(x) = m * x + b
     *  so that we can approximate `f(targetX)`
     *
     * It will search for the 2 closest points in `samplePoints` which contain `targetX`.
     * It will use those 2 closest points to create the function.
     */
    static createLinearFormula({ samplePoints, targetX }) {
        let lowerApprox = [0, 0];
        let higherApprox = [Number.MAX_SAFE_INTEGER, 0];
        for (const curApprox of samplePoints) {
            // estimate the highest available x/y tupel below `targetX`
            if (curApprox[0] <= targetX) {
                if (curApprox[0] > lowerApprox[0]) {
                    lowerApprox = curApprox;
                }
            }
            // estimate the lowest available x/y tupel above `targetX`
            if (curApprox[0] >= targetX) {
                if (curApprox[0] < higherApprox[0]) {
                    higherApprox = curApprox;
                }
            }
        }
        // validate found tupels
        if (lowerApprox[1] === 0 || higherApprox[1] === 0) {
            return undefined;
        }
        const aX = lowerApprox[0];
        const aY = lowerApprox[1];
        const bX = higherApprox[0];
        const bY = higherApprox[1];
        const dX = bX - aX;
        const dY = bY - aY;
        const m = dX === 0 ? 1 : dY / dX;
        const b = aY - aX * m;
        return { m, b };
    }
}
exports.ApproxFormulaUtil = ApproxFormulaUtil;
//# sourceMappingURL=ApproxFormulaUtil.js.map